import React, { useState } from "react";
import "../styles/helppanel.css";
import { useGame } from "../GameContext";

const Helppanel: React.FC = () => {
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="vod-helpPanel" id="vod-helpPanel">
      <img
        src="/img/close.svg"
        id="vod-closeButton"
        alt="Закрыть"
        className="vod-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="vod-helpPivots">
        <div
          className="vod-selectPivots"
          id={showhelpPivots === "pivotTask" ? "vod-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
        <div
          className="vod-selectPivots"
          id={showhelpPivots === "pivotModes" ? "vod-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotModes")}
        >
          Режимы
        </div>
        <div
          className="vod-selectPivots"
          id={showhelpPivots === "pivotButtons" ? "vod-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotButtons")}
        >
          Кнопки
        </div>
        <div
          className="vod-selectPivots"
          id={showhelpPivots === "pivotCommands" ? "vod-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotCommands")}
        >
          Команды
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="vod-commandsCards">
          <div className="vod-helpCard">
            <div className="vod-cardCaption">Суть игры</div>
            <div>
              <div>Получить нужный объём живой воды в любом сосуде</div>
            </div>
          </div>
          <div className="vod-helpCard">
            <div className="vod-cardCaption">Правила игры</div>
            <div>
              <div>
                {" "}
                <>
                <b>C</b> - озеро с живой водой, неиссякаемый сосуд.<br/>
                <b>A</b> и <b>B</b> - сосуды разного объёма, который указан на привязанных карточках.<br/>
                Лягушки показывают текущий объем живой воды в сосудах.<br/>
                <br/>
                Нельзя вылить из пустого сосуда.<br/>
                Нельзя налить в полный сосуд.<br/>
                <br/>
                *Постарайся решить задачу за наименьшее количество команд.
                </>
              </div>
            </div>
          </div>
        </div>
      )}
      {showhelpPivots === "pivotModes" && (
         <div id="car-modesCards">
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="/img/button/control_2.svg"
                className="car-iconhelp"
                alt="знакомство"
              />{" "}
              Знакомство
            </div>{" "}
            <div>
              {" "}
              Ты можешь изучить команды Котобота. Нажимай на кнопки над полем
              кода. И твои действия сразу отобразятся на поле Котобота, без
              написания программы. В этом режиме нельзя ввести код программы,
              поле ввода заблокировано.
            </div>
          </div>
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="/img/button/edit_2.svg"
                className="car-iconhelp"
                alt="программирование"
              />{" "}
              Программирование
            </div>{" "}
            <div>
              {" "}
              Код программы надо писать в поле ввода кода. Для этого используй
              команды Котобота. Команды можно писать самому, а можно ускорить
              процесс с помощью кнопок над полем кода. Они вводят кодовые слова
              целиком.
            </div>
          </div>
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="/img/button/run_2.svg"
                className="car-iconhelp"
                alt="запуск"
              />{" "}
              Запуск
            </div>{" "}
            <div>
              {" "}
              Хочешь увидеть, что делает твоя программа? Запускай, и Котобот
              выполнит её! Если программа уже дописана и она решает задачу,
              Котобот поздравит тебя. Если в программе есть ошибка, ты увидишь
              сообщение о ней. А если программа не дописана, ты увидишь, что уже
              сделано и что ещё осталось дописать.
            </div>
            <br/>
            <div className="car-cardCaption">
              {" "}
              <img
                src="/img/button/stop2.svg"
                className="car-iconhelp"
                alt="стоп"
              />{" "}
              Стоп
            </div>
            <div>
              {" "}
              Останавливает работу программы и переводит в режим программировани.
            </div>
          </div>
          <div className="car-helpCard">
            <div className="car-cardCaption">
              <img
                src="/img/button/debug_2.svg"
                className="car-iconhelp"
                alt="отладка"
              />{" "}
              Отладка
            </div>{" "}
            <div>
              {" "}
              Нужно понять, как работает твой алгоритм? Активируйте отладку! Он
              позволяет исполнить программу пошагово, наблюдая за действиями в
              реальном времени. Ты сможете локализовать ошибку, проверить логику
              условий и циклов, и увидеть точный путь выполнения вашего кода.
              {" "}
            </div>
            <br/>
            <div className="car-cardCaption">
              <img
                src="/img/button/next.svg"
                className="car-iconhelp next-help"
                alt="далее"
              />{" "}
              Далее
            </div>
            <div>
              {" "}
              Выполняет следующую команду программы.
            </div>
          </div>
        </div>
      )}
      {showhelpPivots === "pivotButtons" && (
        <div id="vod-buttonsCardsEdit">
          <div className="vod-helpCard">
            <div className="vod-cardCaption">
              <div className="vod-transButtons-help">
                          <img
            src="/img/button/AB.svg"
            className="vod-icon-help"
            alt="AtoB"
          />
          <img
            src="/img/button/BA.svg"
            className="vod-icon-help"
            alt="BtoA"
          />
          <img
            src="/img/button/CA.svg"
            className="vod-icon-help"
            alt="CtoA"
          />
          <img
            src="/img/button/AC.svg"
            className="vod-icon-help"
            alt="AtoC"
          />
          <img
            src="/img/button/BC.svg"
            className="vod-icon-help"
            alt="BtoC"
          />
          <img
            src="/img/button/CB.svg"
            className="vod-icon-help"
            alt="CtoB"
          />
              </div>
            </div>
              <div>
                Добавляют команды переливания воды из сосуда в сосуд.
              </div>
          </div>
        
        </div>
      )}
      {showhelpPivots === "pivotCommands" && (
        <div id="vod-commandsCards">
          <div className="vod-helpCard">
            <div className="vod-cardCaption">Переливание</div>
            <div>
              <div className="vod-code">
                  <>
                    {" "}
                    <b>pour (x , y)</b> <br />
                    Перелить из сосуда <b>x</b> в сосуд <b>y</b>
                  </>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
